import { useDaily } from 'api/tees/useDaily';
import { HomeTee } from 'components/HomeTee';
import { GoneCountdown } from 'components/GoneCountdown';
import HomeLastChanceTee from 'components/HomeLastChanceTee';
import { useProducts } from 'api/shop/useProducts';
import { ProductItem } from 'components/ProductItem';
import { ScrollIntoView } from 'components/common/ScrollIntoView';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import routeNames from 'router/routeNames.json';
import { Trans, t } from '@lingui/macro';
import { productTypes } from 'constants';
import { useReferralCode } from 'api/referrals/useReferralCode';
import { AddPopup } from 'components/Add/AddPopup';
import ReferralPopupImage from 'assets/referral-popup.png';
import { HomeHead } from 'heads/Home';
import { Pagination } from 'components/Pagination';
import { usePaginatedItems } from 'hooks/usePaginatedItems';

const itemsPerPage = 20;

export default function Home({ lastChance = false }) {
  const { state } = useLocation();
  const { validateReferralCode } = useReferralCode();
  const daily = useDaily();
  const products = useProducts({ product: 'tees' });
  const [limit, setLimit] = useState(itemsPerPage);
  const [showReferralModal, setShowReferralModal] = useState(false);

  let firstRow = daily.data?.dailyTees ?? [];
  let secondRow = daily.data?.lastChanceTees ?? [];

  if (lastChance) {
    [firstRow, secondRow] = [secondRow, firstRow];
  }

  const paginatedProducts = usePaginatedItems(
    products.data,
    itemsPerPage,
    limit
  );

  const validateReferralCodeHandler = async (referralCode) => {
    try {
      const { isValid } = await validateReferralCode(referralCode);
      isValid && setShowReferralModal(true);
    } catch (error) {}
    window.history.replaceState({}, document.title);
  };

  useEffect(() => {
    state?.referralCode && validateReferralCodeHandler(state.referralCode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="w-full [max-width:1350px] mx-auto overflow-hidden">
      <HomeHead />
      <GoneCountdown className="my-2 text-center" />

      <div className="md:mb-12 flex flex-col md:flex-row w-full items-center sm:justify-center">
        {daily.hasInitiallyLoaded
          ? firstRow.map((tee) => <HomeTee key={tee.id} tee={tee} />)
          : new Array(3)
              .fill()
              .map((item, index) => <HomeTee key={index} isLoading />)}
      </div>

      <h1 className="font-sans text-2xl font-bold uppercase [max-width:450px] md:[max-width:none] [width:1140px] mx-auto hidden md:block">
        {lastChance ? t`Today's tees` : t`Last chance tees`}
      </h1>

      <div className="mb-12 flex flex-col md:flex-row w-full items-center justify-center [max-width:1140px] mx-auto">
        <div className="hidden md:flex w-full">
          {secondRow.map((tee) => (
            <HomeLastChanceTee
              key={tee.id}
              tee={tee}
              imageLink={lastChance ? '/' : '/last-chance'}
            />
          ))}
        </div>
        <div className="w-full flex flex-col items-center md:hidden">
          {secondRow.map((tee) => (
            <HomeTee key={tee.id} tee={tee} />
          ))}
        </div>
      </div>

      <div className="mb-16 mx-auto flex flex-col md:flex-row md:justify-center">
        <Link to={routeNames.giftCards} className="flex justify-center">
          <img
            src="https://cdn.qwertee.com/images/gift.jpg"
            alt=""
            width="380px"
            height="300px"
          />
        </Link>
        <Link to={routeNames.teesVotesSelected} className="flex justify-center">
          <img
            src="https://cdn.qwertee.com/images/vote-banner.jpg"
            alt=""
            width="380px"
            height="300px"
          />
        </Link>
        <Link to={routeNames.referral} className="flex justify-center">
          <img
            src="https://cdn.qwertee.com/images/banner-referral.png"
            alt=""
            width="380px"
            height="300px"
          />
        </Link>
      </div>

      <h3 className="font-sans text-2xl font-bold uppercase text-center">
        <Trans>Tee Shop</Trans>
      </h3>
      <div className="[max-width:1140px] sm:mx-auto">
        <div className="mb-12  grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4">
          {paginatedProducts.map((tee) => (
            <ProductItem
              key={tee.id}
              product={tee}
              showFooter
              showDiscount
              type={productTypes.tees}
              link={`${routeNames.shopTees}/${tee.slug}`}
            />
          ))}
        </div>
        <div className="text-end px-4 py-5">
          <Link
            className="text-black hover:text-qw-blue-400 active:text-qw-blue-400 font-bold text-2xl uppercase font-sans"
            to={routeNames.shopTees}
          >
            <Trans>View all</Trans>
          </Link>
        </div>
      </div>
      {limit < products.data?.length && (
        <div className="m-4 w-full text-center">
          <ScrollIntoView
            onScrollIntoView={() => setLimit(limit + itemsPerPage)}
          />
        </div>
      )}
      <Pagination
        totalItems={products.data?.length}
        itemsPerPage={itemsPerPage}
      />
      <AddPopup
        isOpen={showReferralModal}
        onClose={() => setShowReferralModal(false)}
        imgUrl={ReferralPopupImage}
        title={t`CLOSE`}
        bgColor="000"
      />
    </div>
  );
}
